import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixContextMenu from "@radix-ui/react-context-menu";
import { Children } from "react";
export const ContextMenu = (param)=>{
    let { children, trigger, onOpenChange, className, collisionPadding = 8, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs(RadixContextMenu.Root, {
        onOpenChange: onOpenChange,
        dir: "ltr",
        modal: false,
        children: [
            /*#__PURE__*/ _jsx(RadixContextMenu.Trigger, {
                asChild: true,
                children: trigger
            }),
            !!Children.count(children) && /*#__PURE__*/ _jsx(RadixContextMenu.Portal, {
                children: /*#__PURE__*/ _jsx(RadixContextMenu.Content, {
                    className: tailwindMerge("z-portal flex max-h-[var(--radix-context-menu-content-available-height)] w-[216px] min-w-[var(--radix-popper-anchor-width)] flex-col gap-2 overflow-y-auto rounded bg-surface-1 p-2 text-grey-12 shadow-popover outline-none radix-side-left:animate-slide-down radix-side-right:animate-slide-up dark:border dark:border-grey-5", className),
                    "data-testid": "CONTEXT_MENU",
                    collisionPadding: collisionPadding,
                    ...restOfProps,
                    children: children
                })
            })
        ]
    });
};
